import React from "react";

const CustomTextbox = ({
  fieldName,
  error,
  value,
  label,
  handleBlur,
  classes,
  inputType = "text",
  handleChange,
  disabled = false,
  inputProps,
}) => {
  return (
    <div
      className={`form-group ${classes ? classes : ""} mb-3 ${error ? "is-invalid" : "is-valid"
        }`}
    >
      <label className="text-label">{label}</label>
      <input
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        className="input form-control"
        name={fieldName}
        type={inputType}
        disabled={disabled}
        {...inputProps}
      />
      {error && (
        <div
          id={`val-${fieldName}-error`}
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default CustomTextbox;
